(function() {
    'use strict';
  
    angular
      .module('iqxCore')
      .service('pinSvc', pinSvc)

    function pinSvc(ApplicationSvc, toastSvc, $http, $cookies, $window, $location, FormSvc, $q) {
        var svc = this
        svc.create = create
        svc.unlock = unlock
        svc.checkAuth=checkAuth
        svc.prompt=prompt
        svc.prompt_unlock=prompt_unlock
        svc.destroy=destroy_pin
        svc.lock=lock
        svc.setPage='/'

        /////

        function create(pin1, pin2, store=true){
            if(!PINValid(pin1, pin2)){
                return false
            }
            return $http.post('/api/auth/pin/create', {token:ApplicationSvc.currentUser.token,pin:pin1})
            .then(function(res){
                if(store==true){
                    return storePin(res)
                } else {
                    return res.Data
                }                  
            })  
        }

        function PINValid(pin1, pin2){
            if(!pin1 || pin1 === undefined || pin1 === ''){
                toastSvc.error('Error', 'Please enter a PIN.', 'pinerror')
                return false
            }
            if(pin1 !== pin2){
                toastSvc.error('Error', 'PINs do not match.', 'pinerror')
                return false
            }
            if(pin1.length !==4){
                toastSvc.error('Error', 'Invalid PIN length - must be 4 digits.', 'pinerror')
                return false
            }
            return true
        }

        function storePin(res){
            var isCookie=true
            // As we are just creating the pin, store the decrypted version so we can continue to use iqxWEB
            $window.sessionStorage.setItem('IQXToken', ApplicationSvc.currentUser.token)

            var iqxSession = $cookies.getObject('IQXSession')
            if (!iqxSession) {
                iqxSession = $window.sessionStorage.getItem('IQXSession')
                isCookie=false
            }
            iqxSession=angular.fromJson(iqxSession)
            iqxSession.token=res.data // store the encrypted token
            iqxSession.pinauth=ApplicationSvc.currentUser.pinauth=true // be easier to pick up on this!

            if(isCookie){
                $cookies.putObject('IQXSession', iqxSession, ApplicationSvc.cookieOptions)
            } else {
                $window.sessionStorage.setItem('IQXSession', JSON.stringify(iqxSession))
            }
            toastSvc.success('PIN Created', 'Your account on this device is now secured with a PIN.','pincreated')
        }

        function checkAuth(){
            var IQXToken = $window.sessionStorage.getItem('IQXToken')
            if(!IQXToken || IQXToken == ''){
                return true
            } else {
                return false
            }
        }

        function getEncryptedToken(){
            var session = $cookies.getObject('IQXSession')
            if(!session){
                session = $window.sessionStorage.getItem('IQXSession')
            }
            return session.token
        }

        function unlock(pin){
            return $http.post('/api/auth/pin/authenticate', {token:getEncryptedToken(),pin:pin})
            .then(function(res){
                if(res.data === 'INVALID'){
                    toastSvc.error('Invalid PIN', 'The PIN you have entered is invalid, please try again.', 'invalidpin')
                    return $q.reject()
                }
                $http.defaults.headers.common['X-Auth'] = res.data
                $window.sessionStorage.setItem('IQXToken', res.data)
                $location.path((svc.setPage==='/pin' ? '/' : svc.setPage))
                return $q.resolve(true)
            })
        }

        function prompt($scope){
            if(ApplicationSvc.currentUser.pinauth===true){
                return FormSvc.modalForm($scope,'promptPin',{},'xl',true, {}, {}, true)
                .then(function(rtrn){
                    return prompt_unlock(rtrn, $scope)
                })
            } else {
                return $q.resolve(true)
            }
        }

        function prompt_unlock(rtrn, $scope){
            var pin = $scope.pin
            if(rtrn === 0){
                return false
            }
            if(rtrn === 1){
                $scope.pin=''
                return unlock(pin)
            }
        }

        function destroy_pin(){
            if(ApplicationSvc.currentUser.pinauth===true){
                var isCookie=true
    
                var iqxSession = $cookies.getObject('IQXSession')
                if (!iqxSession) {
                    iqxSession = $window.sessionStorage.getItem('IQXSession')
                    isCookie=false
                }
                iqxSession=angular.fromJson(iqxSession)
                iqxSession.token=ApplicationSvc.currentUser.token // store the encrypted token
                iqxSession.pinauth=ApplicationSvc.currentUser.pinauth=undefined // be easier to pick up on this!
    
                if(isCookie){
                    $cookies.putObject('IQXSession', iqxSession, ApplicationSvc.cookieOptions)
                } else {
                    $window.sessionStorage.setItem('IQXSession', JSON.stringify(iqxSession))
                }
                toastSvc.success('PIN Removed', 'PIN authentication will need to be set up again.','pinremoved')

                ApplicationSvc.currentUser.pinauth=undefined
                $window.sessionStorage.removeItem('IQXToken')
                return true
            } else {
                return true
            }
        }

        function lock(inactivity=false){
            delete $http.defaults.headers.common['X-Auth']
            $window.sessionStorage.removeItem('IQXToken')
            $location.url("/pin?inactivity="+inactivity)
        }
    }
})()
